<!-- <button class="control" (click)="toggle()">
    <span class="pause-icon" *ngIf="!paused"></span>
    <span class="play-icon" *ngIf="paused"></span>
  </button> -->

<div class="overlay-confetti" *ngIf="!paused"></div>